export default {
  nav: {
    home: 'Home',
    categories: 'Categories',
    tags: 'Tags',
    about: 'About',
    search: 'Search articles...'
  },
  footer: {
    friendLinks: 'Friend Links: '
  },
  home: {
    subtitle: 'Tech & Life'
  },
  article: {
    all: 'All',
    tag: 'Tag: {0}',
    noArticles: 'No articles',
    views: '{0} views',
    prev: 'Previous',
    next: 'Next',
    notFound: 'Article not found',
    adminOnly: 'This content is visible to administrators only. Please sign in as an admin.',
    commentTitle: 'Comments ({0})'
  },
  comment: {
    nickname: 'Nickname',
    email: 'Email (optional)',
    placeholder: 'Write your comment...',
    submit: 'Submit',
    cancel: 'Cancel',
    nicknameRequired: 'Please enter nickname',
    contentRequired: 'Please enter comment content',
    submitSuccess: 'Comment submitted, pending review',
    empty: 'No comments yet. Be the first!',
    anonymous: 'Anonymous',
    reply: 'Reply'
  },
  sidebar: {
    categories: 'Categories',
    tagCloud: 'Tag Cloud',
    latestArticles: 'Latest Articles',
    noCategories: 'No categories',
    noTags: 'No tags',
    noArticles: 'No articles'
  },
  search: {
    title: 'Search Results',
    placeholder: 'Search articles...',
    button: 'Search',
    resultSummary: 'Results for "<strong>{0}</strong>", {1} found',
    notFound: 'No articles found',
    enterKeyword: 'Enter a keyword to search'
  },
  category: {
    title: 'Categories',
    articleCount: '{0} articles',
    empty: 'No categories'
  },
  pages: {
    title: 'Pages',
    empty: 'No pages',
    notFound: 'Page not found',
    adminOnly: 'This content is visible to administrators only. Please sign in as an admin.',
    uploadTime: 'Uploaded at {0}'
  },
  tag: {
    title: 'Tags',
    empty: 'No tags'
  },
  about: {
    bio: 'A personal blog about tech and life',
    aboutSite: 'About This Site',
    description: 'Welcome to wuBlog! A personal blog built with Vue + Spring Boot, documenting programming learnings, tech sharing, and life notes.',
    techStack: 'Tech Stack',
    contact: 'Contact',
    email: 'Email: {0}',
    github: 'GitHub: {0}'
  },
  langSwitch: '中文'
}
